// extracted by mini-css-extract-plugin
export var hasBackgroundColor = "index-module--hasBackgroundColor--jtJAh";